import AddPANAdminPartial from "../../../../partials/admin/menus/vendors/add-pan-slider.admin.partial";

export default function AddPANAdminScreen() {
  return <AddPANAdminPartial />;
}
